import { Outlet } from "react-router-dom";

import "./styles.scss";

const PageContent = (): JSX.Element => {
  return (
    <div className="container">
      <div className="sub-container">
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default PageContent;
